export default function (str) {
  return str
    .replace(/\s(.)/g, ($1) => { return $1.toUpperCase(); })
    .replace(/\s/g, '')
    .replace(/^(.)/, ($1) => { return $1.toLowerCase(); })
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}




// WEBPACK FOOTER //
// ./src/app/utils/toCamelCase.js